import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	onboardingHeading: {
		id: 'business-conditional-formatting-sidebar.format-rules-sidebar.sidebar.onboarding.onboarding-heading',
		defaultMessage: 'Highlight important work with color',
		description: 'Onboarding title for the format rules feature',
	},
	onboardingDescription: {
		id: 'business-conditional-formatting-sidebar.format-rules-sidebar.sidebar.onboarding.onboarding-description',
		defaultMessage:
			'Create a format rule to quickly view work that needs attention. Only you’ll be able to view the rules you create or edit.',
		description: 'Onboarding message for the format rules feature',
	},
	next: {
		id: 'business-conditional-formatting-sidebar.format-rules-sidebar.sidebar.onboarding.next',
		defaultMessage: 'Next',
		description: 'Cta label to navigate to the next card in the onboarding',
	},
	createRuleOnboarding: {
		id: 'business-conditional-formatting-sidebar.format-rules-sidebar.sidebar.onboarding.create-rule-onboarding',
		defaultMessage:
			'For example, you could create a rule that formats rows red when the due date is before today.',
		description: 'Onboarding message to create a new format rule',
	},
	rulesOrderOnboarding: {
		id: 'business-conditional-formatting-sidebar.format-rules-sidebar.sidebar.onboarding.rules-order-onboarding',
		defaultMessage:
			'If you have multiple rules that apply to the same cell, the rule at the top takes precedence. Drag rules up or down to reorder them.',
		description: 'Onboarding message for the format rules feature',
	},
	done: {
		id: 'business-conditional-formatting-sidebar.format-rules-sidebar.sidebar.onboarding.done',
		defaultMessage: 'Done',
		description: 'Cta label to finalize the onboarding',
	},
	dismiss: {
		id: 'business-conditional-formatting-sidebar.format-rules-sidebar.sidebar.onboarding.dismiss',
		defaultMessage: 'Dismiss',
		description: 'Cta label to dismiss the onboarding',
	},
});
